<template>
    <div class="amount w-100" :class="size">
        <el-button icon="el-icon-minus" @click="numberDec('dec')" circle :class="{'disable':isDisabledDec}"/>
        <el-input class="border-input" type="number" v-model="number" pattern="[0-9]*" :disabled="isDisabled"
                  @focus="$event.currentTarget.select()"
                  @change="checkNumber(true, 'change')"/>
        <el-button icon="el-icon-plus" @click="numberAdd('add')" circle :class="{'disable':isDisabledAdd}"/>
    </div>
</template>

<script>

export default {
    name: "NumberController",
    props: {
        'params': {
            type: Object,
            default: function () {
                return {}
            }
        },
        reset: {required: false, type: Number, default: 0},   //強制 reset用
        size: {default: 'lg'},
    },
    data() {
        return {
            index: this.params.index || 0,
            number: this.params.default || 0,
            min: this.params.min,
            max: this.params.max,
            isDisabledDec: false,
            isDisabledAdd: false,
            isDisabled: this.params.isDisabled || false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        numberDec(operate) {
            if (this.isDisabledDec) {
                this.clickDisabledButton(operate)
            } else {
                this.number--;
                this.checkNumber(true, operate);
            }
        },
        numberAdd(operate) {
            if (this.isDisabledAdd) {
                this.clickDisabledButton(operate)
            } else {
                this.number++;
                this.checkNumber(true, operate);
            }
        },
        checkNumber(isTriggerReturn = false, operate = "") {
            if (typeof this.min === "number") {
                if (this.min >= this.number) {
                    this.isDisabledDec = true
                    this.number = this.min
                } else {
                    this.isDisabledDec = false
                }
            }

            if (typeof this.max === "number") {
                if (this.max <= this.number) {
                    this.isDisabledAdd = true
                    this.number = this.max
                } else {
                    this.isDisabledAdd = false
                }
            }

            if (this.number === "") {
                this.number = (typeof this.min === "number" && this.min >= 0) ? this.min : 0
            }

            this.number = Number(this.number)

            if (isTriggerReturn) {
                this.$emit('triggerEvent', {
                    event: 'returnNumber',
                    index: this.index,
                    number: this.number,
                    operate: operate,
                })
            }
        },
        clickDisabledButton(operate) {
            this.$emit('triggerEvent', {
                event: 'clickDisabledButton',
                index: this.index,
                number: this.number,
                operate: operate,
            })
        },

        /** 設定 number */
        setNumber: function (value, isTriggerReturn, operate) {
            this.number = value;
            this.checkNumber(isTriggerReturn, operate);
        },
    },
    watch: {
        "params.default": {
            handler: function (val) {
                this.number = val
                this.checkNumber(false, "")
            },
            deep: true,
            immediate: true,
        },
        "params.min": {
            handler: function (val) {
                this.min = val
                this.checkNumber(false, "")
            },
            deep: true,
            immediate: true,
        },
        "params.max": {
            handler: function (val) {
                this.max = val
                this.checkNumber(false, "")
            },
            deep: true,
            immediate: true,
        },
        "params.isDisabled": {
            handler: function (val) {
                this.isDisabled = val
            },
            deep: true,
            immediate: true,
        },
        reset: function () {
            //只要 reset有變動，就重置 number
            this.setNumber(this.params.default || 0, false, "");
        },

    }
}
</script>

<style lang="less" scoped>
.amount {
    //margin: 15px;
    display: flex;
    justify-content: center;
    //不可選樣式
    .el-button.disable {
        opacity: .4;
    }

    //大尺寸-預設
    &.lg {
        margin: 25px 0;

        .el-button {
            height: 50px;
            width: 50px;
        }

        .border-input {
            min-height: 50px;
            border-radius: 0;
            border: none;
            border-bottom: 3px solid var(--color-yellow);
            width: 80px;
            margin: 0 30px;

            /deep/ input {
                text-align: center;
                border-width: 0;
                font-size: 20px;
            }
        }
    }

    //小尺寸
    &.mini {
        .el-button {
            border: none;
            color: var(--color-yellow4);
            border-radius: 0;

            &:focus, &:hover {
                background: none;
            }
        }

        .border-input {
            border-radius: 0;
            border: none;
            width: 30px;
            font-size: 16px;

            /deep/ input {
                text-align: center;
                border-width: 0;
                padding: 0;
            }
        }
    }

}
</style>